var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1511_6945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2666 5.50008C4.2666 4.48756 5.08741 3.66675 6.09993 3.66675H17.0999C18.1125 3.66675 18.9333 4.48756 18.9333 5.50008V11.9167V16.5001C18.9333 17.5126 18.1125 18.3334 17.0999 18.3334H6.09993C5.08741 18.3334 4.2666 17.5126 4.2666 16.5001V11.9167V5.50008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9333 11.9167V5.50008C18.9333 4.48756 18.1125 3.66675 17.0999 3.66675H6.09993C5.08741 3.66675 4.2666 4.48756 4.2666 5.50008V11.9167M18.9333 11.9167V16.5001C18.9333 17.5126 18.1125 18.3334 17.0999 18.3334H6.09993C5.08741 18.3334 4.2666 17.5126 4.2666 16.5001V11.9167M18.9333 11.9167H16.563C16.3198 11.9167 16.0867 12.0133 15.9148 12.1852L13.7018 14.3983C13.5298 14.5702 13.2967 14.6667 13.0536 14.6667H10.1463C9.90318 14.6667 9.67002 14.5702 9.49812 14.3983L7.28509 12.1852C7.11318 12.0133 6.88002 11.9167 6.63691 11.9167H4.2666",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1511_6945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.599976)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIc);
export default __webpack_public_path__ + "static/media/product_ic.1df7b8b93fc736fb8975f9cbf0c78476.svg";
export { ForwardRef as ReactComponent };